<template>
    <div class="text-primary cursor-pointer" @click="openModal">
        {{ props.params.data.debtCollectionStatus }}
    </div>
</template>

<script setup lang="ts">

const props = defineProps({
    params: {
        type: Object as () => {
            data: any,
            context: any,
            openModal: Function,
            status: String
        },
        required: true
    }
})

const openModal = () => {
    props.params.openModal(props.params.data)
}

</script>


<style scoped>

</style>